/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Container,
  Stack,
  TextField,
  ButtonGroup,
  Grid,
  MenuItem,
  Typography,
  Card,
  IconButton,
  Tooltip,
  InputAdornment
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Page from '../../../../Page';
import { ToastContainer, toast } from 'react-toastify';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import services from '../../Service';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AlertDialog } from './../../../Common/AlertDialog';

const lenderType = [
  {
    lenderTypeID: '1',
    lenderTypeName: 'Bank'
  },
  {
    lenderTypeID: '2',
    lenderTypeName: ' Finance Company'
  },
  {
    lenderTypeID: '3',
    lenderTypeName: ' Loan Shark'
  },
  {
    lenderTypeID: '4',
    lenderTypeName: ' Friends/Family'
  },
  {
    lenderTypeID: '5',
    lenderTypeName: ' Other'
  }
];

const loanSchema = [
  {
    loanShemaTypeID: '2',
    loanSchemaTypeName: 'No'
  },
  {
    loanShemaTypeID: '1',
    loanSchemaTypeName: 'Yes'
  },
  {
    loanShemaTypeID: '3',
    loanSchemaTypeName: 'Unsure'
  },
];

const activeLoansSchema = [
  {
    activeLoansTypeID: '2',
    activeLoansTypeName: 'No'
  },
  {
    activeLoansTypeID: '1',
    activeLoansTypeName: 'Yes'
  }
];

export function Loan({ handleNext, handleBack, farmerId }) {
  const [message, setMessage] = useState('Delete Confirmation');
  const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
  const [farmerLoanDetailID, setFarmerLoanDetailID] = useState();
  const [loanTypes, setLoanTypeList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [dataGrid, setDataGrid] = useState([]);
  const [lenderTypeID, setlenderTypeID] = useState();
  const [factoryType, setFactoryType] = useState(0);
  const [formData, setFormData] = useState({
    farmerID: 0,
    loanTypeID: 0,
    lenderTypeID: 0,
    other: '',
    loanShemaTypeID: 0,
    purpose: '',
    amountReceived: '',
    rate: '',
    bankID: 0,
    paybackperiod: '',
    remainingPaybackperiod: '',
    activeLoanTypeID: 0,
    nameOfLender: '',
    otherType: ''
  });
  const [pageProps, setPageProps] = useState({
    editingID: 0,
    Edit: false,
    submitButtonName: 'Add',
    pageheadername: 'Add Loan Details '
  });
  const ProductSaveSchema = Yup.object().shape({
    loanShemaTypeID: Yup.number().min(1, 'Please Select Government Funded Loan Scheme').required('Government Funded Loan Scheme Required'),
    other: Yup.string()
      .when('lenderTypeID', {
        is: (lenderTypeID) => lenderTypeID == 5,
        then: Yup.string()
          .required('Other Lender Type is Required').matches(/^[A-Za-z\s]+$/, 'should not allowed symbols or numbers')
          .test('no-leading-space', 'Leading space not allowed', (value) => {
            if (value && value.startsWith(' ')) {
              return false;
            }
            return true;
          }),
        otherwise: Yup.string().nullable(),
      }),
    otherType: Yup.string()
      .when('loanTypeID', {
        is: (loanTypeID) => loanTypeID == 8,
        then: Yup.string()
          .required('Other Loan Type is Required')
          .test('no-leading-space', 'Leading space not allowed', (value) => {
            if (value && value.startsWith(' ')) {
              return false;
            }
            return true;
          }),
        otherwise: Yup.string().nullable(),
      }),
    purpose: Yup.string().matches(/^[A-Za-z\s]+$/, 'should not allowed symbols or numbers').nullable(),
    nameOfLender: Yup.string().matches(/^[A-Za-z\s]+$/, 'should not allowed symbols or numbers').nullable(),
    rate: Yup.string()
      .test('validInterestRate', 'Invalid Interest Rate', function (value) {
        if (!value) {
          return true;
        }
        return /^\d+(\.\d+)?$/.test(value);
      })
      .test('maxInterestRate', 'Interest Rate cannot exceed 100', function (value) {
        if (!value) {
          return true;
        }
        const floatValue = parseFloat(value);
        return !isNaN(floatValue) && floatValue <= 100;
      }).nullable(),
    amountReceived: Yup.string()
      .test('validInterestRate', 'Invalid Amount Received', function (value) {
        if (!value) {
          return true;
        }
        return /^\d+(\.\d+)?$/.test(value);
      }).nullable(),
    paybackperiod: Yup.string().matches(/^[0-9]*$/, 'Only numeric values are allowed').nullable(),
    remainingPaybackperiod: Yup.string().matches(/^[0-9]*$/, 'Only numeric values are allowed').nullable()
  });

  const formik = useFormik({
    initialValues: {
      farmerID: farmerId,
      loanTypeID: formData.loanTypeID,
      lenderTypeID: formData.lenderTypeID,
      loanShemaTypeID: formData.loanShemaTypeID,
      purpose: formData.purpose,
      rate: formData.rate,
      amountReceived: formData.amountReceived,
      bankID: formData.bankID,
      other: formData.other,
      paybackperiod: formData.paybackperiod,
      activeLoanTypeID: formData.activeLoanTypeID,
      nameOfLender: formData.nameOfLender,
      otherType: formData.otherType,
      remainingPaybackperiod: formData.remainingPaybackperiod
    },

    validationSchema: ProductSaveSchema,
    onSubmit: (values) => {
      addGrid(values);
    },
    enableReinitialize: true
  });
  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  useEffect(() => {
    setlenderTypeID(formik.values.lenderTypeID);
  }, [formik.values.lenderTypeID]);

  useEffect(() => {
    trackPromise(GetLoanTypeDetails());
    trackPromise(getBankForDropdown());
    trackPromise(GetAllLoanDetailsbyFarmerID(farmerId));
  }, []);

  useEffect(() => {
    if (formik.values.lenderTypeID !== 5) {
      setValues({
        ...values,
        other: ""
      });
    }
  }, [formik.values.lenderTypeID]);

  useEffect(() => {
    if (formik.values.loanTypeID !== 8) {
      setValues({
        ...values,
        otherType: ""
      });
    }
  }, [formik.values.loanTypeID]);

  async function GetAllLoanDetailsbyFarmerID(farmerId) {
    const res = await services.GetAllLoanDetailsbyFarmerID(farmerId);
    setDataGrid(res);
  }

  async function GetLoanTypeDetails() {
    const loanType = await services.GetLoanTypeDetails();
    if (loanType != null) {
      setLoanTypeList(loanType);
    }
    setFactoryType(parseInt(TokenDecoder.getFactoryTypeFromToken()))
  }

  async function getBankForDropdown() {
    const bank = await services.GetBanksForDropdown();
    if (bank != null) {
      setBankList(bank);
    }
  }
  async function addGrid(values) {
    const exists = dataGrid.find(
      (x) =>
        x.loanTypeID === parseInt(values.loanTypeID) &&
        x.lenderTypeID === parseInt(values.lenderTypeID) &&
        x.loanShemaTypeID === parseInt(values.loanShemaTypeID) &&
        x.purpose === values.purpose &&
        x.rate === values.rate &&
        x.amount === parseFloat(values.amountReceived) &&
        x.paybackperiod === values.paybackperiod &&
        x.remainingPaybackperiod === values.remainingPaybackperiod

    );
    if (exists) {
      toast.error('Details Already Exists.');
    } else {
      if (pageProps.Edit != true) {
        var modelOne = {
          farmerID: parseInt(values.farmerID),
          amountReceived: values.amountReceived == "" ? null : parseFloat(values.amountReceived),
          loanTypeID: parseInt(values.loanTypeID),
          lenderTypeID: parseInt(values.lenderTypeID),
          loanShemaTypeID: parseInt(values.loanShemaTypeID),
          rate: values.rate == "" ? null : parseFloat(values.rate),
          purpose: values.purpose,
          other: values.other == null ? "" : values.other,
          paybackperiod: values.paybackperiod,
          remainingPaybackperiod: values.remainingPaybackperiod,
          createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
          activeLoanTypeID: parseInt(values.activeLoanTypeID),
          otherType: values.otherType,
          nameOfLender: values.nameOfLender

        };
        const res = await services.SaveFarmerLoanDetails(modelOne);
        if (res > 0) {
          toast.success('Loan Details Saved Succesfully');
          trackPromise(GetAllLoanDetailsbyFarmerID(farmerId));
          clearAll();
        } else if (res == -1) {
          toast.error('Loan Detail Already Exists');
        }
        else {
          toast.error('Error Occured In Farmer Loan Details Saving.');
        }
      } else {
        var model = {
          farmerLoanDetailID: parseInt(pageProps.editingID),
          amountReceived: values.amountReceived == 0 ? null : parseFloat(values.amountReceived),
          loanTypeID: parseInt(values.loanTypeID),
          lenderTypeID: parseInt(values.lenderTypeID),
          rate: values.rate == "" ? null : parseFloat(values.rate),
          loanShemaTypeID: parseInt(values.loanShemaTypeID),
          purpose: values.purpose === null ? "" : values.purpose,
          paybackperiod: values.paybackperiod.toString(),
          remainingPaybackperiod: values.remainingPaybackperiod.toString(),
          other: values.other === null ? "" : values.other,
          modifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
          activeLoanTypeID: parseInt(values.activeLoanTypeID),
          otherType: values.otherType === null ? "" : values.otherType,
          nameOfLender: values.nameOfLender === null ? "" : values.nameOfLender
        };
        const res = await services.UpdateFarmerLoanDetails(model);
        if (res.statusCode == 'Success') {
          toast.success('Bank Details Updated Succesfully');
          trackPromise(GetAllLoanDetailsbyFarmerID(farmerId));
          setPageProps({
            ...pageProps,
            editingID: 0,
            Edit: false,
            submitButtonName: 'Add'
          });
          clearAll();
        } else {
          toast.error('Error occured in Farmer Loan Details.');
        }
      }
    }
  }

  async function clearAll() {
    formik.resetForm();
  }

  async function DeleteItem(data) {
    const res = await services.DeleteLoanDetails(data);
    if (res > 0) {
      toast.success('Loan Details Deleted Succesfully');
      trackPromise(GetAllLoanDetailsbyFarmerID(farmerId));
    } else {
      toast.error(res.message);
    }
  }

  function confirmData(y) {
    if (y) {
      DeleteItem(farmerLoanDetailID);
    }
  }

  function handleConfirm(data) {
    setFarmerLoanDetailID(data);
    setEnableConfirmMessage(true);
  }

  function handleEdit(rowData, index) {
    var array = [...dataGrid];
    setValues({
      ...values,
      loanTypeID: rowData.loanTypeID,
      purpose: rowData.purpose,
      amountReceived: rowData.amount == 0 ? "" : rowData.amount,
      lenderTypeID: rowData.lenderTypeID,
      other: rowData.other,
      loanShemaTypeID: rowData.loanShemaTypeID,
      rate: rowData.rate == 0 ? "" : rowData.rate,
      paybackperiod: rowData.paybackperiod == 0 ? "" : rowData.paybackperiod,
      otherType: rowData.otherType,
      activeLoanTypeID: rowData.activeLoanTypeID,
      nameOfLender: rowData.nameOfLender,
      remainingPaybackperiod: rowData.remainingPaybackperiod == 0 ? "" : rowData.remainingPaybackperiod
    });
    array.splice(index, 1);
    setPageProps({
      ...pageProps,
      editingID: rowData.farmerLoanDetailID,
      Edit: true,
      submitButtonName: 'Update'
    });
    setDataGrid(array);
  }

  return (
    <>
      <LoadingComponent />
      <Page title="Loan Details |  FAPS">
        <Container>
          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form
              autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate
              onSubmit={handleSubmit}
            >
              <Card style={{ justifycontent: 'center' }}>
                <Stack spacing={2} margin={3}>
                  <Typography variant="h6">

                    {(factoryType == 1 || factoryType == 3) ? "View Loan Details" : "Loan Details"}
                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right">
                      <ButtonGroup disableElevation variant="outlined" color="primary">
                        <Tooltip title="Bank">
                          <IconButton variant="outlined" color="secondary" onClick={handleBack}>
                            <ArrowBackIosOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Farming">
                          <IconButton variant="outlined" color="secondary" onClick={handleNext}>
                            <ArrowForwardIosOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </ButtonGroup>
                    </Stack>
                  </Typography>
                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={2}
                  >
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Government Funded Loan Scheme *"
                      value={formik.values.loanShemaTypeID}
                      onChange={formik.handleChange}
                      {...getFieldProps('loanShemaTypeID')}
                      error={Boolean(touched.loanShemaTypeID && errors.loanShemaTypeID)}
                      helperText={touched.loanShemaTypeID && errors.loanShemaTypeID}
                      disabled={factoryType == 1 || factoryType == 3}
                    >
                      <MenuItem key={0} value={0}>
                        {' '}
                        Select Government Funded Loan Scheme{' '}
                      </MenuItem>
                      {loanSchema.map((option) => (
                        <MenuItem key={option.loanShemaTypeID} value={option.loanShemaTypeID}>
                          {option.loanSchemaTypeName}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Loan Repayment"
                      value={formik.values.activeLoanTypeID}
                      onChange={formik.handleChange}
                      {...getFieldProps('activeLoanTypeID')}
                      error={Boolean(touched.activeLoanTypeID && errors.activeLoanTypeID)}
                      helperText={touched.activeLoanTypeID && errors.activeLoanTypeID}
                      disabled={factoryType == 1 || factoryType == 3}
                    >
                      <MenuItem key={0} value={0}>
                        {' '}
                        Select Loan Repayment{' '}
                      </MenuItem>
                      {activeLoansSchema.map((option) => (
                        <MenuItem key={option.activeLoansTypeID} value={option.activeLoansTypeID}>
                          {option.activeLoansTypeName}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Lender "
                      value={formik.values.lenderTypeID}
                      onChange={formik.handleChange}
                      {...getFieldProps('lenderTypeID')}
                      error={Boolean(touched.lenderTypeID && errors.lenderTypeID)}
                      helperText={touched.lenderTypeID && errors.lenderTypeID}
                      disabled={factoryType == 1 || factoryType == 3}
                    >
                      <MenuItem key={0} value={0}>
                        {' '}
                        Select Lender
                      </MenuItem>
                      {lenderType.map((option) => (
                        <MenuItem key={option.lenderTypeID} value={option.lenderTypeID}>
                          {option.lenderTypeName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Stack>
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Other Lender *"
                      value={formik.values.other}
                      onChange={formik.handleChange}
                      {...getFieldProps('other')}
                      error={Boolean(touched.other && errors.other)}
                      helperText={touched.other && errors.other}
                      disabled={factoryType == 1 || factoryType == 3 || formik.values.lenderTypeID != 5}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Lending Entity "
                      value={formik.values.nameOfLender}
                      onChange={formik.handleChange}
                      {...getFieldProps('nameOfLender')}
                      error={Boolean(touched.nameOfLender && errors.nameOfLender)}
                      helperText={touched.nameOfLender && errors.nameOfLender}
                      disabled={factoryType == 1 || factoryType == 3}
                    />
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Type of Loan"
                      value={formik.values.loanTypeID}
                      onChange={formik.handleChange}
                      {...getFieldProps('loanTypeID')}
                      error={Boolean(touched.loanTypeID && errors.loanTypeID)}
                      helperText={touched.loanTypeID && errors.loanTypeID}
                      disabled={factoryType == 1 || factoryType == 3}
                    >
                      <MenuItem key={0} value={0}>
                        {' '}
                        Select Type of Loan
                      </MenuItem>
                      {loanTypes.map((option) => (
                        <MenuItem key={option.loanTypeID} value={option.loanTypeID}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Stack>
                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={2}
                  >
                    <TextField
                      fullWidth
                      size="small"
                      label="Other Loan Type *"
                      value={formik.values.otherType}
                      onChange={formik.handleChange}
                      {...getFieldProps('otherType')}
                      error={Boolean(touched.otherType && errors.otherType)}
                      helperText={touched.otherType && errors.otherType}
                      disabled={factoryType == 1 || factoryType == 3 || formik.values.loanTypeID != 8}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Purpose of Loan"
                      value={formik.values.purpose}
                      onChange={formik.handleChange}
                      {...getFieldProps('purpose')}
                      error={Boolean(touched.purpose && errors.purpose)}
                      helperText={touched.purpose && errors.purpose}
                      disabled={factoryType == 1 || factoryType == 3}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Amount Received "
                      value={formik.values.amountReceived}
                      onChange={formik.handleChange}
                      {...getFieldProps('amountReceived')}
                      error={Boolean(touched.amountReceived && errors.amountReceived)}
                      helperText={touched.amountReceived && errors.amountReceived}
                      disabled={factoryType == 1 || factoryType == 3}
                    />
                  </Stack>
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Total Payback Period "
                      value={formik.values.paybackperiod}
                      onChange={formik.handleChange}
                      {...getFieldProps('paybackperiod')}
                      error={Boolean(touched.paybackperiod && errors.paybackperiod)}
                      helperText={touched.paybackperiod && errors.paybackperiod}
                      disabled={factoryType == 1 || factoryType == 3}
                      InputProps={{
                        endAdornment: <InputAdornment position="start">Months</InputAdornment>
                      }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Remaining Payback Period "
                      value={formik.values.remainingPaybackperiod}
                      onChange={formik.handleChange}
                      {...getFieldProps('remainingPaybackperiod')}
                      error={Boolean(touched.remainingPaybackperiod && errors.remainingPaybackperiod)}
                      helperText={touched.remainingPaybackperiod && errors.remainingPaybackperiod}
                      disabled={factoryType == 1 || factoryType == 3}
                      InputProps={{
                        endAdornment: <InputAdornment position="start">Months</InputAdornment>
                      }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Interest Rate (%)"
                      value={formik.values.rate}
                      onChange={formik.handleChange}
                      {...getFieldProps('rate')}
                      error={Boolean(touched.rate && errors.rate)}
                      helperText={touched.rate && errors.rate}
                      disabled={factoryType == 1 || factoryType == 3}
                    />
                  </Stack>
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <LoadingButton
                      size="medium"
                      type="button"
                      variant="outlined"
                      color="error"
                      onClick={() => clearAll()}
                      disabled={pageProps.Edit || factoryType == 1 || factoryType == 3}
                    >
                      Clear
                    </LoadingButton>
                    <LoadingButton
                      size="medium"
                      type="submit"
                      variant="outlined"
                      color="secondary"
                      disabled={factoryType == 1 || factoryType == 3}
                    >
                      {pageProps.submitButtonName}
                    </LoadingButton>
                  </Stack>
                  <Divider variant="middle" />
                  {dataGrid.length > 0 ? (
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <Card style={{ justifycontent: 'center', width: '65rem' }}>
                        <TableContainer component={Paper}>
                          <Table aria-label="caption table">
                            <TableHead>
                              <TableRow>
                                <TableCell>Government Funded Loan Scheme</TableCell>
                                <TableCell>Type of Loan</TableCell>
                                <TableCell>Purpose of Loan</TableCell>
                                <TableCell>Amount Received</TableCell>
                                <TableCell>Lender</TableCell>
                                <TableCell>Total Payback Period (Month)</TableCell>
                                <TableCell>Remaining Payback Period (Month)</TableCell>
                                <TableCell>Interest Rate (%)</TableCell>
                                {(factoryType == 1 || factoryType == 3) ? null :
                                  <TableCell align="center">Action</TableCell>}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {dataGrid.map((rowData, index) => (
                                <TableRow key={index}>
                                  <TableCell>
                                    {rowData.loanShemaTypeID == 2
                                      ? 'No'
                                      : rowData.loanShemaTypeID == 1
                                        ? 'Yes'
                                        : 'Unsure'}
                                  </TableCell>
                                  <TableCell >
                                    {rowData.name}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ borderBottom: 'none' }}
                                  >
                                    {rowData.purpose}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ borderBottom: 'none' }}
                                  >
                                    {rowData.amount == 0 ? "" : parseFloat(rowData.amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ borderBottom: 'none' }}
                                  >
                                    {rowData.lenderTypeID == 1
                                      ? 'Bank'
                                      : rowData.lenderTypeID == 2
                                        ? 'Finance Company'
                                        : rowData.lenderTypeID == 3
                                          ? 'Loan Shark'
                                          : rowData.lenderTypeID == 4
                                            ? 'Friends/Family'
                                            : rowData.other}
                                  </TableCell>

                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ borderBottom: 'none' }}
                                  >
                                    {rowData.paybackperiod == 0 ? "" : rowData.paybackperiod}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ borderBottom: 'none' }}
                                  >
                                    {rowData.remainingPaybackperiod == 0 ? "" : rowData.remainingPaybackperiod}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ borderBottom: 'none' }}
                                  >
                                    {rowData.rate == 0 ? "" : rowData.rate}
                                  </TableCell>
                                  {(factoryType == 1 || factoryType == 3) ? null :
                                    <TableCell
                                      align="center"
                                      component="th"
                                      scope="row"
                                      style={{ borderBottom: 'none' }}
                                    >
                                      <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" >
                                        {pageProps.Edit != true ? (
                                          <Tooltip title="Edit">
                                            <IconButton
                                              variant="outlined"
                                              onClick={() => handleEdit(rowData, index)}
                                            >
                                              <EditIcon />
                                            </IconButton>
                                          </Tooltip>
                                        ) : null}
                                        <Tooltip title="Delete">
                                          <IconButton
                                            variant="outlined"
                                            color="error"
                                            onClick={(e) => handleConfirm(rowData.farmerLoanDetailID)}
                                          >
                                            <DeleteIcon />
                                          </IconButton>
                                        </Tooltip>
                                      </Stack>
                                    </TableCell>}
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Card>
                    </Stack>
                  ) : null}
                </Stack>
              </Card>
            </Form>
          </FormikProvider>
        </Container>
        <div hidden={true}>
          <Grid item>
            <AlertDialog
              confirmData={confirmData}
              headerMessage={message}
              viewPopup={EnableConfirmMessage}
              discription={'Are you sure want to delete loan details ?'}
              setViewPopup={setEnableConfirmMessage}
            />
          </Grid>
        </div>
      </Page>
    </>
  );
}
